import { apiSlice } from "../../api/apiSlice";
import { accessUserAction, platformUserAction } from "./accessUserSlice";

export const accessApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAccessGroupUsers: builder.query({
      query: ({ companyId, type }) =>
        `Keyfree/getAccessGroupUsers?companyId=${companyId ?? ""}&type=${
          type ?? ""
        }`,
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          if (result.data.data?.length > 0) {
            dispatch(
              accessUserAction({
                accessUserList: result.data.data,
              })
            );
          }
        } catch (err) {}
      },
    }),
    getPlatformUsers: builder.query({
      query: ({ UserRoleId, CompanyId, type }) =>
        `UserList?UserRoleId=${UserRoleId ?? 0}&CompanyId=${CompanyId ?? ""}&type=${
          type ?? ""
        }`,
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          if (result.data.data?.length > 0) {
            dispatch(
              platformUserAction({
                platformUserList: result.data.data,
              })
            );
          }
        } catch (err) {}
      },
    }),

  }),
});

export const { useLazyGetAccessGroupUsersQuery, useLazyGetPlatformUsersQuery } = accessApi;
